import * as i1 from '@egovsolutions/angular-egov-api/session/internal';
import { FORCE_SHORT_SESSION_TIMES } from '@egovsolutions/angular-egov-api/session/internal';
export { FORCE_SHORT_SESSION_TIMES, PASSWORD_VALIDATOR } from '@egovsolutions/angular-egov-api/session/internal';
import * as i0 from '@angular/core';
import { Component, NgModule, Injectable, Optional, Inject } from '@angular/core';
import { interval, switchMap, EMPTY, first, BehaviorSubject } from 'rxjs';
import { switchMap as switchMap$1, distinctUntilChanged } from 'rxjs/operators';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2$1 from '@angular/material/snack-bar';

const frontEndUserAdapter = (_response) => {
    const response = JSON.parse(JSON.stringify(_response));
    return {
        id: response.user.user.id,
        personalInfo: {
            ...response.user.user.personalInfo,
            contact: response.user.user.contact,
        },
        paymentMethods: [],
    };
};

const backEndUserAdapter = (_response) => {
    const response = JSON.parse(JSON.stringify(_response));
    return {
        id: response.user.user.id,
        username: ''
    };
};

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
class SessionAboutToExpireComponent {
    constructor(
    // Dependencies
    ngZone, lifetimeManager, changeDetector) {
        this.ngZone = ngZone;
        this.lifetimeManager = lifetimeManager;
        this.changeDetector = changeDetector;
    }
    // Initialization
    ngOnInit() {
        this.setRemainingTime();
        this.startTrackingRemainingTime();
    }
    startTrackingRemainingTime() {
        this.ngZone.runOutsideAngular(() => {
            this.intervalSubscription = interval(100).subscribe(() => this.setRemainingTime());
        });
    }
    setRemainingTime() {
        this.lifetimeManager.session$.pipe(switchMap(session => session ? session.expiration$ : EMPTY), first()).subscribe(lastExpirationTime => {
            if (lastExpirationTime) {
                let timeInSeconds = Math.floor((lastExpirationTime - this.lifetimeManager.EARLY_EXPIRY - Date.now()) / 1000);
                if (timeInSeconds < 0)
                    timeInSeconds = 0;
                let seconds = timeInSeconds % 60 + '';
                const minutes = Math.floor(timeInSeconds / 60);
                if (seconds.length === 1)
                    seconds = '0' + seconds;
                const newRemainingTime = `${minutes}:${seconds}`;
                if (newRemainingTime !== this.remainingTime) {
                    this.remainingTime = newRemainingTime;
                    this.changeDetector.detectChanges();
                }
            }
        });
    }
    // Clear subscriptions
    ngOnDestroy() {
        if (this.intervalSubscription)
            this.intervalSubscription.unsubscribe();
    }
}
SessionAboutToExpireComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: SessionAboutToExpireComponent, deps: [{ token: i0.NgZone }, { token: i1.SessionLifetimeManager }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
SessionAboutToExpireComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.1.2", type: SessionAboutToExpireComponent, selector: "app-session-about-to-expire", ngImport: i0, template: `
        <ng-container *ngIf="remainingTime === undefined">Your session is about to expire due to inactivity.</ng-container>
        <ng-container *ngIf="remainingTime !== undefined"> Your session will expire in {{ remainingTime }} due to inactivity. </ng-container>
    `, isInline: true, styles: [":host-context{display:flex;justify-content:space-between;align-items:center;height:100%;line-height:20px;opacity:1}\n"], directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: SessionAboutToExpireComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-session-about-to-expire', template: `
        <ng-container *ngIf="remainingTime === undefined">Your session is about to expire due to inactivity.</ng-container>
        <ng-container *ngIf="remainingTime !== undefined"> Your session will expire in {{ remainingTime }} due to inactivity. </ng-container>
    `, styles: [":host-context{display:flex;justify-content:space-between;align-items:center;height:100%;line-height:20px;opacity:1}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.NgZone }, { type: i1.SessionLifetimeManager }, { type: i0.ChangeDetectorRef }]; } });
class SessionAboutToExpireModule {
}
SessionAboutToExpireModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: SessionAboutToExpireModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SessionAboutToExpireModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: SessionAboutToExpireModule, declarations: [SessionAboutToExpireComponent], imports: [CommonModule] });
SessionAboutToExpireModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: SessionAboutToExpireModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: SessionAboutToExpireModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [SessionAboutToExpireComponent],
                }]
        }] });

class SessionLifetimeUI {
    constructor(
    // Dependencies
    lifetimeManager, snackBar, ngZone, forceShortSessionTimes) {
        this.lifetimeManager = lifetimeManager;
        this.snackBar = snackBar;
        this.ngZone = ngZone;
        this.forceShortSessionTimes = forceShortSessionTimes;
        // Session
        this.expiration$ = (() => {
            const behaviorSubject = new BehaviorSubject(undefined);
            this.lifetimeManager.session$.pipe(switchMap$1(session => session ? session.expiration$ : EMPTY), distinctUntilChanged()).subscribe(behaviorSubject);
            return behaviorSubject;
        })();
        // Durations
        this.EXPIRY_WARNING_TIME = this.forceShortSessionTimes
            ? 30 * 1000
            : 60 * 2.5 * 1000;
        // Check UI required
        this.interval = interval(1000);
        this.init();
    }
    // Initialize
    init() {
        this.lifetimeManager.hasUserSession$.subscribe(hasUserSession => {
            if (hasUserSession)
                this.startCheckingUI();
            else
                this.stopCheckingUI();
        });
        this.checkExpired();
    }
    startCheckingUI() {
        this.ngZone.runOutsideAngular(() => {
            this.checkWarning();
            this.intervalSubscription = this.interval.subscribe(() => this.checkWarning());
        });
    }
    stopCheckingUI() {
        if (this.intervalSubscription) {
            this.intervalSubscription.unsubscribe();
            delete this.intervalSubscription;
        }
    }
    checkWarning() {
        if (!this.warningUIRef) {
            if (this.shouldShowWarning()) {
                this.ngZone.run(() => {
                    const warningUIRef = this.snackBar.openFromComponent(SessionAboutToExpireComponent, { duration: 1000 * 365 * 24 * 60 * 60 * 1000 /* A thousand years (virtually forever) */ });
                    this.warningUIRef = warningUIRef;
                    this.warningUIRef.afterDismissed().subscribe(() => {
                        if (this.warningUIRef === warningUIRef)
                            delete this.warningUIRef;
                    });
                });
            }
        }
        else {
            if (!this.shouldShowWarning())
                this.ngZone.run(() => this.warningUIRef?.dismiss());
        }
    }
    shouldShowWarning() {
        return !!this.lifetimeManager.hasUserSession$.value && !this.lifetimeManager.sendingKeepAlive &&
            Date.now() >= this.expiration$.value - this.EXPIRY_WARNING_TIME - this.lifetimeManager.EARLY_EXPIRY;
    }
    checkExpired() {
        this.lifetimeManager.sessionExpired
            .subscribe(() => this.notifySessionExpired());
    }
    notifySessionExpired() {
        const sessionExpiredRef = this.snackBar.open('Your session has expired', 'Dismiss', { duration: 1000 * 365 * 24 * 60 * 60 * 1000 /* Forever */ });
        this.sessionExpiredRef = sessionExpiredRef;
        this.sessionExpiredRef.onAction().subscribe(() => sessionExpiredRef.dismiss());
        this.sessionExpiredRef.afterDismissed().subscribe(() => {
            if (this.sessionExpiredRef === sessionExpiredRef)
                delete this.sessionExpiredRef;
        });
    }
}
SessionLifetimeUI.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: SessionLifetimeUI, deps: [{ token: i1.SessionLifetimeManager }, { token: i2$1.MatSnackBar }, { token: i0.NgZone }, { token: FORCE_SHORT_SESSION_TIMES, optional: true }], target: i0.ɵɵFactoryTarget.Injectable });
SessionLifetimeUI.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: SessionLifetimeUI, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: SessionLifetimeUI, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i1.SessionLifetimeManager }, { type: i2$1.MatSnackBar }, { type: i0.NgZone }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [FORCE_SHORT_SESSION_TIMES]
                }] }]; } });

/**
 * Generated bundle index. Do not edit.
 */

export { SessionLifetimeUI, backEndUserAdapter, frontEndUserAdapter };
